import { z } from 'zod';

export const ContactPreferencesOptionSchema = z.enum(['bingo', 'casino', 'betting']);
export const ContactPreferencesKeySchema = z.enum(['email', 'sms', 'phone']);
export const ContactPreferencesNewSchema = z.object({
    type: ContactPreferencesKeySchema,
    categories: ContactPreferencesOptionSchema.array(),
});

export type ContactPreferencesNewOptionType = z.infer<typeof ContactPreferencesOptionSchema>;
export type ContactPreferencesNewKeyType = z.infer<typeof ContactPreferencesKeySchema>;
export type ContactPreferencesNewType = z.infer<typeof ContactPreferencesNewSchema>;

export const InputSchema = z.object({
    customerId: z.number(),
    contactPreferences: ContactPreferencesNewSchema.array(),
});

export type ChangeContactPreferencesInputType = z.infer<typeof ContactPreferencesNewSchema>;
